import init from '@/pages/base'
import App from './App.vue'

init(App)
